module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img2.06ec02adc78c0ec6d4759c678347d348.jpg";